"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = exports.deletion = void 0;
const observable_1 = require("../reactivity/observable");
const unique_id_1 = require("../shared/unique-id");
const deletion = (element, callback) => {
    const onMutation = (mutationsList, observer) => {
        if (mutationsList.length && !document.body.contains(element)) {
            callback();
            observer.disconnect();
        }
    };
    const observer = new MutationObserver(onMutation);
    observer.observe(element, {
        childList: true,
        subtree: true,
    });
};
exports.deletion = deletion;
const render = async (context, container) => {
    let prev = null;
    if (context instanceof observable_1.Observable) {
        const onContext = (element) => {
            if (typeof element === 'boolean' ||
                element === null ||
                element === undefined) {
                return;
            }
            if (prev && (0, unique_id_1.getElementId)(element) === (0, unique_id_1.getElementId)(prev)) {
                return;
            }
            if (prev && container.contains(prev)) {
                prev.replaceWith(element);
            }
            else if (element) {
                container.appendChild(element);
            }
            prev = element;
        };
        const subscription = context.subscribe(onContext);
        (0, exports.deletion)(container, () => subscription.unsubscribe());
    }
    else {
        if (typeof context === 'function') {
            container.appendChild(context());
        }
        else {
            container.appendChild(context);
        }
    }
};
exports.render = render;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVuZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3BhY2thZ2VzL2NvcmUvcmVuZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHlEQUFzRDtBQUN0RCxtREFBbUQ7QUFFNUMsTUFBTSxRQUFRLEdBQUcsQ0FBQyxPQUFvQixFQUFFLFFBQW9CLEVBQUUsRUFBRTtJQUNyRSxNQUFNLFVBQVUsR0FBRyxDQUNqQixhQUErQixFQUMvQixRQUEwQixFQUMxQixFQUFFO1FBQ0YsSUFBSSxhQUFhLENBQUMsTUFBTSxJQUFJLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLEVBQUU7WUFDNUQsUUFBUSxFQUFFLENBQUM7WUFDWCxRQUFRLENBQUMsVUFBVSxFQUFFLENBQUM7U0FDdkI7SUFDSCxDQUFDLENBQUM7SUFFRixNQUFNLFFBQVEsR0FBRyxJQUFJLGdCQUFnQixDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBRWxELFFBQVEsQ0FBQyxPQUFPLENBQUMsT0FBTyxFQUFFO1FBQ3hCLFNBQVMsRUFBRSxJQUFJO1FBQ2YsT0FBTyxFQUFFLElBQUk7S0FDZCxDQUFDLENBQUM7QUFDTCxDQUFDLENBQUM7QUFqQlcsUUFBQSxRQUFRLFlBaUJuQjtBQUVLLE1BQU0sTUFBTSxHQUFHLEtBQUssRUFDekIsT0FLNEIsRUFDNUIsU0FBc0IsRUFDdEIsRUFBRTtJQUNGLElBQUksSUFBSSxHQUF1QixJQUFJLENBQUM7SUFFcEMsSUFBSSxPQUFPLFlBQVksdUJBQVUsRUFBRTtRQUdqQyxNQUFNLFNBQVMsR0FBRyxDQUFDLE9BQW9CLEVBQUUsRUFBRTtZQUN6QyxJQUNFLE9BQU8sT0FBTyxLQUFLLFNBQVM7Z0JBQzVCLE9BQU8sS0FBSyxJQUFJO2dCQUNoQixPQUFPLEtBQUssU0FBUyxFQUNyQjtnQkFDQSxPQUFPO2FBQ1I7WUFFRCxJQUFJLElBQUksSUFBSSxJQUFBLHdCQUFZLEVBQUMsT0FBTyxDQUFDLEtBQUssSUFBQSx3QkFBWSxFQUFDLElBQUksQ0FBQyxFQUFFO2dCQUN4RCxPQUFPO2FBQ1I7WUFNRCxJQUFJLElBQUksSUFBSSxTQUFTLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxFQUFFO2dCQUNwQyxJQUFJLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDO2FBQzNCO2lCQUFNLElBQUksT0FBTyxFQUFFO2dCQUNsQixTQUFTLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDO2FBQ2hDO1lBRUQsSUFBSSxHQUFHLE9BQU8sQ0FBQztRQUNqQixDQUFDLENBQUM7UUFFRixNQUFNLFlBQVksR0FBRyxPQUFPLENBQUMsU0FBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDO1FBRWxELElBQUEsZ0JBQVEsRUFBQyxTQUFTLEVBQUUsR0FBRyxFQUFFLENBQUMsWUFBWSxDQUFDLFdBQVcsRUFBRSxDQUFDLENBQUM7S0FDdkQ7U0FBTTtRQUNMLElBQUksT0FBTyxPQUFPLEtBQUssVUFBVSxFQUFFO1lBQ2pDLFNBQVMsQ0FBQyxXQUFXLENBQUMsT0FBTyxFQUFFLENBQUMsQ0FBQztTQUNsQzthQUFNO1lBQ0wsU0FBUyxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQztTQUNoQztLQUNGO0FBQ0gsQ0FBQyxDQUFDO0FBbERXLFFBQUEsTUFBTSxVQWtEakIifQ==